module.exports = __webpack_public_path__ + "static/media/README.f7a5384b.md";